<ion-header style="z-index: 102">
  <ion-toolbar class="barra-superior">
    <ion-buttons slot="start" class="d-none d-md-flex">
      <ion-menu-button />
    </ion-buttons>
    @if (name() !== '') {
    <h1>
      {{ name() }}
      @if (breadcrumb() !== '') {
      <span class="text-muted">
        <span style="font-size: 12px">></span> {{ breadcrumb() }}
      </span>
      }
    </h1>
    }
    <ion-buttons slot="end">
      <ion-avatar
        class="p-3"
        role="button"
        (click)="router.navigate(['/profile'])"
      >
        @if (avatar(); as avatarData) {
        <lib-text-avatar
          [text]="avatarData.name || '!'"
          [color]="avatarData.background || 'yellow'"
          [textColor]="avatarData.color || 'black'"
        />
        }
      </ion-avatar>
    </ion-buttons>
    <ion-title />
  </ion-toolbar>
</ion-header>
